export default __webpack_public_path__ + "static/media/send-icon.8cad5ec4.svg";